import { render, staticRenderFns } from "./headerLink.vue?vue&type=template&id=2bcc55f8&"
import script from "./headerLink.vue?vue&type=script&lang=js&"
export * from "./headerLink.vue?vue&type=script&lang=js&"
import style0 from "./headerLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports